module.exports = "https://static.futunn.com/components/common-redpacket-prize-list/images/no-crowd.15b995ab06.png";